<script lang="ts" module>
  import type { AiSuggestion } from '@/teoCore/TeoApi';
  import type { DropDownItem } from '@/ui/elements/dropdown/DropDown/DropDownSelect.svelte';
  import { useActiveText } from '@/utils/teo-context';

  import AiSuggestionsPanel from './AiSuggestionsPanel.svelte';

  namespace AISuggestions {
    export interface Props {
      suggestions: AiSuggestion[];
      finalStateMessage?: string;
      loading?: boolean;
      onSuggestionUsed?: (aiSuggestion: AiSuggestion) => void;
      onRemoveSuggestion: (index: number) => void;
      onLoadAiSuggestionClick: (type: string) => void;
      promptItems?: DropDownItem<string>[];
      promptItemSelected?: string;
      onPromptSelect?: (item: string) => void;
      promptType?: 'buttons' | 'dropdown';
    }
  }
</script>

<script lang="ts">
  let teoText = useActiveText();
  let props: AISuggestions.Props = $props();

  function onInsertClick(aiSuggestion?: AiSuggestion): void {
    if (!aiSuggestion) {
      console.warn('No AI suggestion provided');
      return;
    }
    teoText.current.ai.useSuggestion({
      markerId: aiSuggestion.context.replacementWrapper,
      replacement: aiSuggestion.text,
    });
    props.onSuggestionUsed?.(aiSuggestion);
  }
</script>

<!-- {#if props.loading}
  <div class="flex h-20 overflow-hidden rounded-sm">
    <LoadingArea />
  </div>
{:else} -->
<AiSuggestionsPanel
  suggestions={props.suggestions}
  onRemoveSuggestion={props.onRemoveSuggestion}
  loading={props.loading}
  onSuggestionUsed={onInsertClick}
  finalStateMessage={props.finalStateMessage}
  onLoadAiSuggestionClick={props.onLoadAiSuggestionClick}
  promptType={props.promptType}
  promptItems={props.promptItems}
  promptItemSelected={props.promptItemSelected}
  onPromptSelect={props.onPromptSelect}
/>
<!-- {/if} -->
